import axios from 'axios';
import { store } from '../store/storeModules.js';

// 設定 axios 攔截器
axios.interceptors.request.use(
  config => {
    const loginData = store.getters['user/getLoginData'];
    if (loginData && loginData.access_token) {
      config.headers.Authorization = `Bearer ${loginData.access_token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default axios; 